import { CloseCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import React from 'react'
import { Flex, Text } from 'theme-ui'
import theme from '../../../../common/theme'

const DeleteRuleConfirmation = ({ onOk, onCancel }) => {
  return (
    <Modal
      visible
      okText="Yes"
      cancelText="Cancel"
      okType="danger"
      title={
        <Flex>
          <Text
            sx={{ color: theme.stylebook.icons.modals.danger.iconColor, mr: 2 }}
          >
            <CloseCircleOutlined translate="no" />
          </Text>
          Delete ignore
        </Flex>
      }
      onOk={onOk}
      onCancel={onCancel}
      maskClosable
    >
      <Flex sx={{ flexDirection: 'column', gap: 2 }}>
        <Text>Are you sure you want to delete this ignore?</Text>
      </Flex>
    </Modal>
  )
}

export default DeleteRuleConfirmation
